export const actingBrandFilter =
  (permissions, service, permission) => brands => {
    return brands.filter(({ value }) => {
      const hasBrandSupportPermission =
        permissions[value]?.[service]?.[permission];
      return hasBrandSupportPermission;
    });
  };
